<template>
  <div class="hot-sales">
    <div class="section-header">
      <span class="icon">🔥</span>
      <h3>热卖HOT</h3>
              <router-link 
          :to="{
            path: '/feature-zone',
            query: { advertCode: 'NEW_HOME_HOTPRODUCT' }
          }"
          class="more-link"
        >
        more >
      </router-link>
    </div>
    <div class="products-grid">
      <div
        class="product-item"
        v-for="item in productList"
        :key="item.ProductNo"
        @click="handleProductClick(item)"
      >
        <img :src="getImageUrl(item.ImageUrl)" :alt="item.Title" />
        <p class="price"><small>¥</small>{{ item.Param1 }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { getAdvertList } from "@/api/advertisement";
import { AdvertCodes } from "@/api/constants/advertCodes";

export default {
  name: "HotSales",

  data() {
    return {
      productList: [],
    };
  },

  created() {
    this.loadHotProducts();
  },

  methods: {
    async loadHotProducts() {
      try {
        const params = {
          Kind: "PRODUCT",
          AdvertCode: "NEW_HOME_HOTPRODUCT",
          PageIndex: 1,
          PageSize: 2,
          CheckTime: "",
        };

        const res = await getAdvertList("NEW_HOME_HOTPRODUCT", params);
        if (res?.Data) {
          this.productList = res.Data;
        }
      } catch (error) {
        console.error("获取热卖商品失败:", error);
      }
    },

    getImageUrl(imageUrlString) {
      try {
        const imageData = JSON.parse(imageUrlString)[0];
        return imageData.ServerUrl
          ? `${imageData.ServerUrl}${imageData.FilePath}`
          : imageData.FilePath;
      } catch (error) {
        console.error("解析图片URL失败:", error);
        return "";
      }
    },

    handleProductClick(product) {
      if (product.Url) {
        window.location.href = product.Url;
      }
    },
  },
};
</script>

<style scoped>
.hot-sales {
  flex: 1;
  padding: 10px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  padding: 0 8px;
}

.section-header h3 {
  margin: 0 10px;
  font-size: 16px;
}

.products-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  padding: 0 8px;
}

.product-item {
  text-align: center;
  cursor: pointer;
}

.product-item img {
  width: 100%;
  height: auto;
  border-radius: 4px;
}

.price {
  color: #ff4444;
  font-weight: bold;
  margin: 5px 0;
}

.price small {
  font-size: 12px;
  margin-right: 2px;
}
</style>
